/** A vertical "more actions" glyph. MoreOutlined's dots are too spindly to
 * read in a grid cell, and scaling that icon up makes them taller rather than
 * heavier -- so the glyph is drawn here instead, sized for weight. Inherits
 * its trigger's color. */
export function VerticalDots() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{
            width: 4,
            height: 4,
            borderRadius: '50%',
            backgroundColor: 'currentColor',
          }}
        />
      ))}
    </div>
  )
}
